import { put, takeLatest } from 'redux-saga/effects';
import { EditDataScadenza } from '../../reducers/r_index';
import { MessageType, Message } from '../../utils/variables';

import authService from './../../components/api-authorization/AuthorizeService';

// utils
import format from 'date-fns/format';

// worker saga: makes the api call when triggerAction sees the action
export function* runAction({ payload: { pk, data_scadenza, codiceUtente } }) {
    try {
        const token = yield authService.getAccessToken();

        const response = yield fetch('/Licenses/EditDataScadenzaLicense/'
            + pk + '/'
            + (data_scadenza === null ? null : format(data_scadenza, 'yyyy-MM-dd')) + '/'
            + codiceUtente, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });


        const responseResult = yield response.text();


        if (responseResult === Message.Updated) {
            yield put(EditDataScadenza.creators.editDataScadSuccess({ responseResult }));
        }
        else if (responseResult === Message.NotUpdated) {
            yield put(EditDataScadenza.creators.editDataScadFailed("Impossibile estendere la data di scadenza della licenza selezionata."));
        }
        else if (responseResult.substring(0, 5) === MessageType.Error) {
            //se il messaggio è un errore, rimuovo [ERR] all'inizio
            yield put(EditDataScadenza.creators.EditDataScadenzaFailed(responseResult.substring(5)));
        }
        else yield put(EditDataScadenza.creators.EditDataScadenzaFailed(responseResult));


    } catch (e) {
        yield put(EditDataScadenza.creators.editDataScadFailed(e.message)); // failed to fetch data
    }
}

// watcher saga: watches for actions dispatched to the store, starts runAction
export function* triggerAction() {
    yield takeLatest(EditDataScadenza.types.EDIT_DATA_SCAD_REQUEST, runAction);
}